export default {

    fromPageModel(model) {
        if (model) {
            const containers = this.parseContainers(manywho.utils.getObjectDataProperty(model.properties, 'PageContainers').objectData);

            const componentObjectData = manywho.utils.getObjectDataProperty(model.properties, 'PageComponents').objectData;
            const components = (componentObjectData) ? componentObjectData.map(this.parseObjectDataProperties) : [];

            const newModel = this.parseObjectDataProperties(model);
            newModel.pageContainers.data = containers;
            newModel.pageComponents.data = components;
            newModel.element.developerName = model.developerName;
            newModel.element.externalId = model.externalId;
            newModel.element.internalId = model.internalId;
            newModel.element.isSelected = model.isSelected;
            newModel.element.order = model.order;
            newModel.element.typeElementId = model.typeElementId;
            return newModel;
        }

        return null;
    },

    toPageModel(modelData) {
        if (modelData) {
            let modelDataCopy = $.extend(true, {}, modelData);
            modelDataCopy.pageContainers.data = this.convertContainersToObjectData(modelDataCopy.pageContainers.data);
            modelDataCopy.pageComponents.data = modelDataCopy.pageComponents.data.map((component) => this.convertToObjectDataProperties(component));

            return this.convertToObjectDataProperties(modelDataCopy);
        }

        return null;
    },

    parseObjectDataProperties(objectData) {
        const result = {
            element: {
                developerName: objectData.developerName,
                externalId: objectData.externalId,
                internalId: objectData.internalId,
                isSelected: objectData.isSelected,
                order: objectData.order,
                typeElementId: objectData.typeElementId
            }
        };
        objectData.properties.forEach((property) => {
            const propertyName = property.developerName.substr(0, 1).toLowerCase() + property.developerName.substr(1);

            result[propertyName] = {
                value: property.contentValue,
                data: property.objectData,
                contentType: property.contentType,
                typeElementPropertyId: property.typeElementPropertyId
            }
        });
        return result;
    },

    convertToObjectDataProperties(object) {
        const result = [];
        for (let property in object) {
            if (property != 'element') {
                const propertyName = property.substr(0, 1).toUpperCase() + property.substr(1);

                if (object[property]) {
                    result.push({
                        contentType: object[property].contentType || null,
                        contentValue: manywho.utils.isNullOrUndefined(object[property].value) ? null : object[property].value,
                        developerName: propertyName,
                        objectData: object[property].data || null,
                        typeElementPropertyId: object[property].typeElementPropertyId || null
                    })
                }
            }
        }
        return {
            developerName: object.element.developerName,
            externalId: object.element.externalId || null,
            internalId: object.element.internalId|| null,
            isSelected: object.element.isSelected || false,
            order: object.element.order || 0,
            typeElementId: object.element.typeElementId || null,
            properties: result
        };
    },

    parseContainers(pageContainers, parentContainerId) {
        if (!pageContainers)
            return [];

        return pageContainers.map((container) => {
            const properties = this.parseObjectDataProperties(container);
            if (properties.pageContainers.data) {
                properties.pageContainers.data = this.parseContainers(properties.pageContainers.data, properties.id.value);
            }
            return manywho.utils.extend({ parentContainer: parentContainerId || null}, properties, true);
        })
    },

    convertContainersToObjectData(pageContainers) {
        return pageContainers.map((container) => {
            if (container) {
                const containerData = container.data ? container.data : container;
                const newContainer = containerData.properties ? containerData: this.convertToObjectDataProperties(containerData);

                if (manywho.utils.getObjectDataProperty(newContainer.properties, 'PageContainers').objectData) {
                    manywho.utils.getObjectDataProperty(newContainer.properties, 'PageContainers').objectData = this.convertContainersToObjectData(manywho.utils.getObjectDataProperty(newContainer.properties, 'PageContainers').objectData);
                }
                return newContainer;
            }
        });
    },

    removeContainer(id, containers) {
        const filteredContainer = [];
        for (const container of containers) {
            if (container.pageContainers.data) {
                container.pageContainers.data = this.removeContainer(id, container.pageContainers.data);
            }
            if (container.id.value != id)
                filteredContainer.push(container);
        }
        return filteredContainer;
    },

    findContainer(id, containers) {
        if (!Array.isArray(containers))
            containers = [containers];
        var foundContainer = null;
        containers.forEach((container) => {
            if (foundContainer)
                return foundContainer;
            const containerId = container.id.value;
            if (containerId && manywho.utils.isEqual(containerId, id, true)) {
                foundContainer = container;
            } else {
                const childContainers = container.pageContainers;
                if (childContainers && childContainers.data) {
                    for (const childContainer of childContainers.data) {
                        foundContainer = this.findContainer(id, childContainer);
                        if (foundContainer)
                            return foundContainer;
                    }
                }
            }
        });
        return foundContainer;
    },

    findComponent(id, components) {
        for (const component of components) {
            const componentId = component.id;
            if (componentId && componentId.value == id) {
                return component;
            }
        }
        return null;
    },

    getFlatContainers(containers, flatContainers) {

        if (!Array.isArray(containers))
            containers = [containers];

        containers.forEach((container) => {
            const containerData = container;

            flatContainers.push(containerData);

            const childContainers = container.pageContainers.data;

            if (childContainers)
                this.getFlatContainers(childContainers, flatContainers);
        }, this);

        return flatContainers;
    },

    stripValues(elements) {
        return elements.map((element) => {
            const stripped = {};
            for (const prop in element) {
                if (element.hasOwnProperty(prop)) {
                    if (element[prop]) {

                        let value = element[prop].value;
                        if (value === null) {
                            // If there's no value, assume it's object data
                            stripped[prop] = element[prop].data;
                        } else {
                            // If the value is a stringy scalar, assign the value as the real scalar type
                            if (manywho.utils.isNullOrEmpty(value)) {
                                stripped[prop] = value;
                            } else if (value === 'True') {
                                stripped[prop] = true;
                            } else if (value === 'False') {
                                stripped[prop] = false;
                            } else if (!isNaN(value)) {
                                stripped[prop] = +value; // Convert to a real number type
                            } else {
                                stripped[prop] = value;
                            }
                        }

                    }
                }
            }
            if (element && element.pageContainers && element.pageContainers.data) {
                stripped.pageContainers = this.stripValues(element.pageContainers.data);
            }
            return stripped;
        });
    },

    generatePageComponentInputs(componentConfig) {
        let inputs = [];
        for (const property in componentConfig.properties) {
            for (const componentProperty of componentConfig.properties[property]) {
                let objectData = inputs.filter((input) => input['Component' + componentProperty] != null)[0];
                let newObjectData = manywho.utils.extend({}, objectData, true);
                if (!newObjectData)
                    newObjectData = {};
                if (!newObjectData['Component' + componentProperty])
                    newObjectData['Component' + componentProperty] = {};
                if (!newObjectData['Component' + componentProperty][property])
                    newObjectData['Component' + componentProperty][property] = {};
                if (!newObjectData['Component' + componentProperty].element) {
                    newObjectData['Component' + componentProperty].element = {};
                    newObjectData['Component' + componentProperty].element.developerName = 'Component Property';
                }
                switch(property) {
                    case 'isVisible':
                        newObjectData['Component' + componentProperty][property].typeElementPropertyId = 'f75150c1-f163-4590-97e3-77a291dfe089';
                        break;
                    case 'isEditable':
                        newObjectData['Component' + componentProperty][property].typeElementPropertyId = 'e297b0d9-03dc-41ce-9aef-7b294556110d';
                        break;
                    case 'isRequired':
                        newObjectData['Component' + componentProperty][property].typeElementPropertyId = 'ee1f3bd6-28dc-4fcd-99fa-c4b9b61010c5';
                        break;
                }
                newObjectData['Component' + componentProperty][property].contentType = 'ContentString';
                newObjectData['Component' + componentProperty][property].value = true;

                if (!objectData) {
                    inputs.push(newObjectData);
                } else {
                    inputs = inputs.map((input) => {
                        if (input['Component' + componentProperty]) {
                            return newObjectData;
                        }
                        return input;
                    });
                }
            }
        }
        inputs = inputs.map((input) => {
            for (const prop in input) {
                input[prop] = {
                    objectData: this.convertToObjectDataProperties(input[prop]),
                    typeElementDeveloperName: 'Component Property'
                }
            }
            return input;
        });
        return inputs;
    },

    guid() {
        let s4 = function() {
            return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
        };
        return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
    },

    fromModel(model) {
        if (model) {
            return model.map((item) => {
                const developerName = manywho.utils.getObjectDataProperty(item.properties, 'DeveloperName');
                const typeElementId = manywho.utils.getObjectDataProperty(item.properties, 'TypeElementId').contentValue;
                const properties = manywho.utils.getObjectDataProperty(item.properties, 'Properties').objectData || [];

                return {
                    developerName: developerName ? developerName.contentValue : item.developerName,
                    typeElementId: typeElementId ? typeElementId : null,
                    properties: properties.map(property => {
                        if (property.properties) {
                            const id = manywho.utils.getObjectDataProperty(property.properties, 'TypeElementPropertyId').contentValue
                            const developerName = manywho.utils.getObjectDataProperty(property.properties, 'DeveloperName');
                            const typeElementId = manywho.utils.getObjectDataProperty(property.properties, 'TypeElementId');

                            return {
                                developerName: (developerName) ? developerName.contentValue : property.developerName,
                                typeElementId: (typeElementId) ? typeElementId.contentValue : null,
                                contentType: manywho.utils.getObjectDataProperty(property.properties, 'ContentType').contentValue,
                                contentFormat:  manywho.utils.getObjectDataProperty(property.properties, 'ContentFormat').contentValue,
                                typeElementPropertyId: id,
                                contentValue:  manywho.utils.getObjectDataProperty(property.properties, 'ContentValue').contentValue,
                                objectData: this.fromModel(manywho.utils.getObjectDataProperty(property.properties, 'ObjectData').objectData)
                            }
                        }
                        else
                            return property;
                    })
                }
            });
        }

        return null;
    },

    toModel(objectEditorData) {
        if (objectEditorData) {
            return objectEditorData.map((item) => {
                return {
                    developerName: item.developerName,
                    typeElementId: item.typeElementId,
                    properties: Array.from(item.properties.values()).map((property) => {
                        return {
                            developerName: property.developerName,
                            typeElementId: property.typeElementId,
                            properties: [
                                { developerName: 'ContentValue', contentValue: property.contentValue },
                                { developerName: 'ContentType', contentValue: property.contentType },
                                { developerName: 'ContentFormat', contentValue: property.contentFormat },
                                { developerName: 'TypeElementId', contentValue: property.typeElementId },
                                { developerName: 'ObjectData', contentValue: this.toModel(property.objectData) },
                                { developerName: 'TypeElementPropertyId', contentValue: property.id }
                            ]
                        }
                    })
                }
            });
        }

        return null;
    }

}
